import type { Chat, ChatConfig } from 'config/types.ts';

declare global {
  interface Window {
    __lc: { license: number; integration_name: string; product_name: string };
    LiveChatWidget:
      | {
          call: (action: string, ...props: unknown[]) => void;
          on: (event: string, handler: (...args: unknown[]) => void) => void;
        }
      | undefined;
  }
}

export type ChatProps = { config: ChatConfig };
export type ChatHook<T extends ChatConfig['type']> = (
  config: Omit<Chat<T>, 'type'>,
) => void;

export enum ChatVisibilityState {
  MINIMIZE = 'minimize',
  HIDE = 'hide',
}
